import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Panindiacorporatecabservice() {



  const cardData =
  {
    keyword: ' Pan India Corporate Cab Service ',
    heading: 'Pune Corporate Cars India Private Limited: Pan India Corporate Cab Service  ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Pan India Corporate Cab Service, delivering seamless transportation solutions for businesses, IT parks, industrial zones, and corporate offices across the country. Our extensive fleet of well-maintained sedans, SUVs, MUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, managers, business delegates, and senior executives in any city or industrial region. Whether it is daily employee commute, shift-based transportation, airport transfers, inter-city business travel, plant visits, client meetings, or VIP mobility, we offer smooth and hassle-free nationwide travel support. With trained chauffeurs, GPS-enabled vehicles, 24×7 assistance, and flexible corporate rental plans, Pune Corporate Cars India Private Limited ensures a dependable and premium transportation experience for businesses operating anywhere across India.',

    top: 'Top Places to Visit in India with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "The Taj Mahal is one of the world’s most iconic monuments, built by Mughal Emperor Shah Jahan in memory of his wife Mumtaz Mahal. Known for its white marble beauty, intricate craftsmanship, and romantic legacy, it is a UNESCO World Heritage Site and India’s most visited landmark."
  },
  {
    "title": "Jaipur, Rajasthan",
    "description": "Jaipur, the Pink City, is famous for its royal palaces, grand forts, and traditional markets. Historic sites including Hawa Mahal, Amber Fort, City Palace, and Jantar Mantar showcase the architectural brilliance and rich heritage of Rajasthan’s royal era."
  },
  {
    "title": "Varanasi, Uttar Pradesh",
    "description": "Varanasi is one of the world’s oldest living cities, renowned for its spiritual atmosphere, ancient temples, and sacred ghats along the Ganges River. Evening Ganga Aarti, narrow lanes, and centuries-old traditions make it a major destination for cultural and religious travelers."
  },
  {
    "title": "Goa",
    "description": "Goa is India’s most popular beach destination, known for its golden beaches, Portuguese architecture, nightlife, seafood, and laid-back lifestyle. Visitors enjoy water sports, coastal forts, charming churches, and the unique blend of Indian and Western cultures."
  },
  {
    "title": "Kerala Backwaters",
    "description": "The Kerala backwaters offer a serene network of lakes, canals, and lagoons surrounded by lush tropical greenery. Houseboat cruises, traditional villages, coconut plantations, and rich biodiversity make it one of India’s most relaxing and picturesque travel experiences."
  },
  {
    "title": "Mumbai, Maharashtra",
    "description": "Mumbai is India’s financial capital, famous for its colonial architecture, Bollywood film industry, Marine Drive, Gateway of India, and vibrant urban culture. The city blends modern skyscrapers, coastal views, cultural landmarks, and fast-paced city life."
  },
  {
    "title": "Delhi",
    "description": "Delhi is a historic and modern metropolis, home to ancient monuments, political landmarks, and diverse markets. Popular attractions include Red Fort, Humayun’s Tomb, Qutub Minar, India Gate, Chandni Chowk, and modern urban centers like Connaught Place."
  },
  {
    "title": "Himalayan Region – Himachal & Uttarakhand",
    "description": "The Indian Himalayas offer scenic hill stations, snow-clad peaks, religious sites, adventure sports, and peaceful natural retreats. Popular destinations include Shimla, Manali, Kedarnath, Rishikesh, Mussoorie, Nainital, and the Valley of Flowers."
  },
  {
    "title": "Kolkata, West Bengal",
    "description": "Kolkata is known for its cultural heritage, literature, colonial architecture, and vibrant festivals. Landmarks such as Victoria Memorial, Howrah Bridge, Dakshineswar Temple, and Park Street showcase the city’s artistic and historical charm."
  },
  {
    "title": "Andaman & Nicobar Islands",
    "description": "The Andaman & Nicobar Islands offer tropical beaches, coral reefs, marine life, and pristine natural landscapes. Popular spots include Radhanagar Beach, Cellular Jail, Havelock Island, and adventure activities like scuba diving and snorkeling."
  }
],


"services": [
  {
    "name": "All India Corporate Cab Services",
    "description": "All India Corporate Cab Services provides end-to-end employee and executive transport solutions across India. Equipped with sedans, SUVs, and shuttle vehicles, it ensures safe, punctual, and reliable transport with GPS tracking and professional drivers for all corporate locations nationwide."
  },
  {
    "name": "Nationwide Employee Transport",
    "description": "Nationwide Employee Transport offers structured workforce mobility services across cities and industrial hubs in India. Features include route optimization, multi-shift support, real-time tracking, and professional chauffeurs for safe and efficient daily commuting."
  },
  {
    "name": "Pan India Staff Shuttle",
    "description": "Pan India Staff Shuttle provides high-capacity shuttle services for bulk employee movement across corporate campuses nationwide. Includes AC minibuses, optimized routes, automated attendance integration, and strict safety protocols for organized staff commutes."
  },
  {
    "name": "Business Travel Cab Pan India",
    "description": "Business Travel Cab Pan India delivers corporate travel solutions for client visits, inter-office trips, airport transfers, and business meetings across India. Modern sedans and SUVs with professional chauffeurs ensure a seamless and comfortable travel experience."
  },
  {
    "name": "Corporate Fleet Pan India",
    "description": "Corporate Fleet Pan India offers comprehensive fleet management solutions for companies operating across India. Includes sedans, SUVs, shuttles, driver management, maintenance support, GPS tracking, and compliance monitoring for scalable corporate mobility."
  },
  {
    "name": "Monthly Corporate Cab Pan India",
    "description": "Monthly Corporate Cab Pan India delivers long-term corporate transport contracts with dedicated vehicles, trained drivers, and GPS monitoring. Ideal for companies requiring consistent employee commute solutions nationwide."
  },
  {
    "name": "Outstation Corporate Taxi Pan India",
    "description": "Outstation Corporate Taxi Pan India provides long-distance corporate travel for meetings, client visits, factory tours, and executive road trips. Features comfortable vehicles, experienced chauffeurs, route planning, and live tracking across states."
  },
  {
    "name": "Airport Corporate Cab India",
    "description": "Airport Corporate Cab India offers reliable corporate airport transfers, including pick-up and drop services for employees and executives. Equipped with sedans, SUVs, professional drivers, and GPS-enabled tracking for punctual arrivals and departures."
  },
  {
    "name": "Sedan Corporate Cab India",
    "description": "Sedan Corporate Cab India delivers premium sedans for executive commute, airport runs, and corporate travel. Features professionally maintained interiors, safety measures, and trained drivers for a comfortable ride."
  },
  {
    "name": "SUV Corporate Cab India",
    "description": "SUV Corporate Cab India provides spacious and high-comfort SUVs for team travel, executive mobility, and long-distance corporate trips. Includes trained chauffeurs and advanced safety monitoring for a premium travel experience."
  },
  {
    "name": "Luxury Corporate Cab India",
    "description": "Luxury Corporate Cab India offers high-end vehicles for VIP executives, business meetings, and special corporate events. Ensures plush interiors, professional chauffeurs, and superior service standards nationwide."
  },
  {
    "name": "Affordable Corporate Cab India",
    "description": "Affordable Corporate Cab India provides cost-effective corporate transport solutions without compromising safety, reliability, or comfort. Ideal for SMEs, startups, and mid-sized organizations seeking economical daily commute options."
  },
  {
    "name": "Company Transport Pan India",
    "description": "Company Transport Pan India provides comprehensive staff transport solutions, including employee commutes, executive transfers, and visitor movement across multiple cities. Ensures organized, reliable, and secure transport operations nationwide."
  },
  {
    "name": "Employee Mobility Pan India",
    "description": "Employee Mobility Pan India delivers flexible, tech-enabled commuting solutions for employees with GPS tracking, multi-shift support, and real-time monitoring. Optimized for corporate operations across India."
  },
  {
    "name": "Corporate Chauffeur Service India",
    "description": "Corporate Chauffeur Service India offers professional drivers for executives, VIP clients, and corporate travel across India. Ensures safe, punctual, and premium travel experience for business clients."
  }
],

"tableData": [
  ["All India Corporate Cab Services", "Nationwide Employee Transport"],
  ["Pan India Staff Shuttle", "Business Travel Cab Pan India"],
  ["Corporate Fleet Pan India", "Monthly Corporate Cab Pan India"],
  ["Outstation Corporate Taxi Pan India", "Airport Corporate Cab India"],
  ["Sedan Corporate Cab India", "SUV Corporate Cab India"],
  ["Luxury Corporate Cab India", "Affordable Corporate Cab India"],
  ["Company Transport Pan India", "Employee Mobility Pan India"],
  ["Corporate Chauffeur Service India", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Pan India Corporate Cab Service",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable Pan India corporate cab services, ensuring seamless and efficient transportation for employees and business executives across major cities and industrial hubs in India."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs nationwide, helping employees reach offices, factories, and corporate events on time, no matter the city or region."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring secure and comfortable commutes for corporate clients across India."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel anywhere in India."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate cab rental plans to meet the unique commuting requirements of companies and employees across all states in India."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel across the country."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives anywhere in India."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed seamlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free across India."
  }
]




















  }

  
const faqData = [
  {
    question: 'Do you provide Pan India corporate cab services?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services across India for offices, industrial hubs, and corporate events.',
  },
  {
    question: 'What types of corporate transportation services are available Pan India?',
    answer: 'We provide employee transportation, airport transfers, corporate pickups and drops, shuttle services, outstation travel, and complete fleet management for corporate clients across all major cities in India.',
  },
  {
    question: 'Do you support daily employee commute services across multiple cities?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees in all locations where we operate.',
  },
  {
    question: 'How can companies book Pan India corporate cab services?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for Pan India corporate cab services?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts Pan India?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management across all cities.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features across India?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety at every location.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts Pan India?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules across India.',
  },
  {
    question: 'What payment options are available for Pan India corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing across all locations.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Khanna',
    feedback: 'Highly reliable Pan India corporate cab service. Smooth operations, professional drivers, and timely pickups across all our offices.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Nair',
    feedback: 'Excellent corporate transportation partner across India. Employees appreciate the comfort, safety, and punctuality of the service.',
    rating: 5,
  },
];

















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pan India Corporate Cab Service",
  "image": "https://www.punecorporatecars.com/assets/images/pan-india-corporate-cab.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers Pan India Corporate Cab Services, including nationwide employee transport, staff shuttles, business travel cabs, corporate fleet services, monthly corporate cabs, outstation corporate taxis, airport corporate cabs, sedan & SUV corporate cabs, luxury corporate cabs, affordable corporate transport, company transport across India, employee mobility, and corporate chauffeur services.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/pan-india-corporate-cab-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Pan India Corporate Cab Service | Employee & Business Transport Across India</title>

  <meta
    name="description"
    content="Pan India corporate cab services offering nationwide employee transport, business travel cabs, corporate fleet services, outstation corporate taxis, airport corporate cabs, sedan & SUV corporate cabs, luxury corporate transport, affordable cabs, employee mobility, and corporate chauffeur services across India."
  />

  <meta
    name="keywords"
    content="All India Corporate Cab Services, Nationwide Employee Transport, Pan India Staff Shuttle, Business Travel Cab Pan India, Corporate Fleet Pan India, Monthly Corporate Cab Pan India, Outstation Corporate Taxi Pan India, Airport Corporate Cab India, Sedan Corporate Cab India, SUV Corporate Cab India, Luxury Corporate Cab India, Affordable Corporate Cab India, Company Transport Pan India, Employee Mobility Pan India, Corporate Chauffeur Service India"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Panindiacorporatecabservice;